import type { FC } from 'react';
import type { IIconProps } from '@/Module/Icon/Model';
import { BaseIcon } from './BaseIcon';
export const IconDownload: FC<IIconProps> = props => {
  return <BaseIcon {...props} data-sentry-element="BaseIcon" data-sentry-component="IconDownload" data-sentry-source-file="IconDownload.tsx">
      <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="IconDownload.tsx">
        <path d="M2.30029 8.38533L9.82717 16.2706M9.82717 16.2706L17.3541 8.38533M9.82717 16.2706L9.82717 0.500024" stroke="currentColor" strokeWidth="2" data-sentry-element="path" data-sentry-source-file="IconDownload.tsx" />
        <path d="M0.866699 20.5L18.7878 20.5" stroke="currentColor" strokeWidth="2" data-sentry-element="path" data-sentry-source-file="IconDownload.tsx" />
      </svg>
    </BaseIcon>;
};